import style from "css/hotdesking.module.css";
import { CalendarPicker, ConfigProvider } from "antd-mobile";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import enUS from "antd-mobile/es/locales/en-US";
import koKR from "antd-mobile/es/locales/ko-KR";

function SearchCalendar({ isOpen, onClose, onSelect, date }) {
  const { t, i18n } = useTranslation();
  const [selectDate, setSelectDate] = useState(null);

  useEffect(() => {
    if (isOpen && selectDate === null) {
      setSelectDate(date);
    }
  }, [date, isOpen, selectDate]);

  const onCloseCalendar = () => {
    setSelectDate(null);
    onClose();
  };

  return (
    <ConfigProvider locale={i18n.language === "ko-KR" ? koKR : enUS}>
      <CalendarPicker
        className={`${style.popup} ${style.calendar}`}
        visible={isOpen}
        selectionMode="single"
        title={t("HOTDESKING.MODAL.SEARCH.CALENDAR")}
        onConfirm={onSelect}
        confirmText={t("HOTDESKING.BUTTON.CONFIRM")}
        onChange={(date) => setSelectDate(date)}
        onClose={onCloseCalendar}
        value={selectDate}
        min={new Date()}
        allowClear={false}
        closeOnMaskClick
      />
    </ConfigProvider>
  );
}

export default SearchCalendar;
